<template>
  <div class="search-input">
    <span class="search-icon"></span>
    <van-field
      ref="inputRef"
      :value="value"
      @input="onInput"
      :clearable="clearable"
      type="text"
      :placeholder="placeholder"
      enterkeyhint="done"
      @clear="onInputClear"
      @keydown.enter.stop="onInputComplete"
    />
  </div>
</template>
<script>
// import { judgeDeviceType } from "@/utils/device";
// const winHeight = window.innerHeight;
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    placeholder: {
      type: String,
      default: "",
    },
  },
  mounted() {
    // if (judgeDeviceType.isAndroid) {
    //   window.addEventListener("resize", this.onAndroidKeyboardDown);
    // }
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.onAndroidKeyboardDown);
  },
  methods: {
    onSearch() {
      this.$emit("search", this.value);
    },
    onInput(value) {
      this.$emit("input", value);
      this.onSearch();
    },
    onInputFocus() {
      this.$emit("focus");
    },
    onInputComplete() {
      this.onSearch();
      this.$refs.inputRef.blur();
    },
    onInputClear() {
      this.onSearch();
    },
    // onInputBlur() {
    //   this.$emit("blur");
    // },
    // onAndroidKeyboardDown() {
    //   if (window.innerHeight === winHeight) {
    //     // 安卓键盘收起
    //     this.onInputBlur();
    //   }
    // },
  },
};
</script>
<style lang="less" scoped>
.search-input {
  position: relative;
  /deep/.van-cell {
    box-sizing: border-box;
    padding: 0;
    height: 70px;
  }
  /deep/.van-field__value {
    height: 70px;
  }
  /deep/.van-field__control {
    flex: none;
    box-sizing: border-box;
    padding: 0 74px;
    width: 100%;
    height: 70px;
    background: #f3f7fa;
    border-radius: 35px;
    border: 1px solid #c7c7c7;
    font-size: 28px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #333333;
    line-height: 68px;
    &:focus {
      border-color: #3583fb;
    }
  }
  /deep/.van-field__clear {
    position: absolute;
    margin: 0;
    padding: 0;
    right: 0;
    top: 0;
    width: 70px;
    height: 70px;
    &::before {
      position: absolute;
      right: 22px;
      top: 25px;
      content: "";
      width: 20px;
      height: 20px;
      background: url(../images/icon_close@2x.png) center/cover;
    }
  }
  .search-icon {
    position: absolute;
    z-index: 1;
    left: 22px;
    top: 22px;
    width: 28px;
    height: 30px;
    background: url(../images/icon_search@2x.png) center/cover;
  }
}
</style>